import { render, staticRenderFns } from "./edit-user-form.vue?vue&type=template&id=18b37b5f&scoped=true"
import script from "./edit-user-form.vue?vue&type=script&lang=js"
export * from "./edit-user-form.vue?vue&type=script&lang=js"
import style0 from "./edit-user-form.vue?vue&type=style&index=0&id=18b37b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b37b5f",
  null
  
)

export default component.exports